import { observer } from 'mobx-react'
import React, { useEffect } from 'react'

import { Config } from '@flowwai-frontend/bps-officer-web/env-config'
import { APIStatus, API_SUCCESS } from '@flowwai-frontend/shared/api-common'
import { LoadingWrapper } from '@flowwai-frontend/shared/common-components'
import { useAccountStore } from '@flowwai-frontend/shared/sales-crm/sales-crm-core'

import { GlobalSearchType } from '../../types/index'
import GlobalSearchContentController from '../GlobalSearchContentController/GlobalSearchContentController'
import GlobalSearchTemplateController from '../GlobalSearchTemplateController/GlobalSearchTemplateController'
import useGetContactTemplateBasicDetails from './apis/useGetContactTemplateBasicDetails'

const GlobalSearchController = (): React.ReactElement => {
   const getContactTemplateAPIObj = useGetContactTemplateBasicDetails()
   const accountStore = useAccountStore()

   const globalSearchType = Config.GLOBAL_SEARCH_TYPE as GlobalSearchType

   useEffect(() => {
      if (accountStore.contactTemplateId) return
      getContactTemplateAPIObj.triggerAPI()
   }, [])

   const renderSuccessView = (): React.ReactElement => {
      switch (globalSearchType) {
         case 'TEMPLATE':
            return <GlobalSearchTemplateController />
         case 'PIPELINE':
         default:
            return <GlobalSearchContentController />
      }
   }

   const getAPIStatus = (): APIStatus =>
      accountStore.contactTemplateId
         ? API_SUCCESS
         : getContactTemplateAPIObj.apiStatus

   return (
      <LoadingWrapper
         apiError={getContactTemplateAPIObj.apiError}
         apiStatus={getAPIStatus()}
         containerClassName='w-[640px] h-[100px]'
      >
         {renderSuccessView()}
      </LoadingWrapper>
   )
}

export default observer(GlobalSearchController)
